import { getLocaleCode } from "locales";
import moment from "moment";
import intl from "react-intl-universal";

export const ISO_DATE_FORMAT = 'YYYY-MM-DD';
export const DATA_FORMAT_TYPES = { WITH_YEAR: "L", WITHOUT_YEAR: "[DM]" };

/**
  * @param {*} date date to be formatted.
  * @param {*} formatDateCode code to format date.
  * @returns Returns the date formatted according to the user's language .
  * Example in pt-BR: getDataFormat('2020-05-02', DATA_FORMAT_TYPES.WITH_YEAR); /returns => "02/05/2020"
*/
export const getDataFormat = (date, formatDateCode) => {
  if (!date) {
    return '-'
  } else {
    return moment(date).format(formatDateCode);
  }
}

const getDateFormatByLanguage = (language) => {
  switch(language){
    case 'pt-BR':
    case 'es-ES':
    case 'es-MX':
    case 'en-GB':
      return 'DD/MM/YYYY';
    case 'en-US':
    case 'en-CA':
    case 'en-ZA':
    default:
      return 'MM/DD/YYYY';
  }
}

/**
  * @param {*} date date to be formatted, type string.
  * @returns Returns the date formatted with full month name and time.
  * Example in pt-BR: getFullDateWithTime('2026-08-20T00:00:00'); /returns => "20 de agosto de 2026 às 00:00"
*/
export const getFullDateWithTime = (date) => {
  if (!date) return '-';

  return moment(date).format(intl.get("commons.fullDateWithTime"));
}

/**
  * @param {*} date date to be formatted, type string.
  * @returns Returns the date formatted in the ISO format without time.
  * Example param in pt-BR: getDataFormat('16/09/2025'); /returns => "2025-09-16"
*/
export const getDateInISOFormat = (date) => {
  if (!date) return '';

  const currentLanguage = getLocaleCode();
  const currentDateFormat = getDateFormatByLanguage(currentLanguage);

  return moment(date, currentDateFormat).format("YYYY-MM-DD");
}
